type MixedFontTextProps = {
  text: string;
  normalClassName?: string;
  highlightClassName?: string;
  wrapperClassName?: string;
};

export default function MixedFontText({
  text,
  normalClassName = "font-dancing text-4xl md:text-5xl opacity-90",
  highlightClassName = "font-montserrat font-bold text-5xl md:text-6xl",
  wrapperClassName = "leading-tight",
}: MixedFontTextProps) {
  const parts = text.split(/(\*\*.*?\*\*)/g);

  return (
    <p
      className={`
        ${wrapperClassName}
        max-w-full
        break-words
      `}
    >
      {parts.map((part, idx) =>
        part.startsWith("**") && part.endsWith("**") ? (
          <span key={idx} className={`${highlightClassName} mx-1 inline`}>
            {part.slice(2, -2)}
          </span>
        ) : (
          <span
            key={idx}
            className={`${normalClassName} whitespace-normal inline`}
          >
            {part}
          </span>
        )
      )}
    </p>
  );
}
